import React from "react";
import { PaymentMethodSelectorProps } from "./PaymentMethod.types";
import { FlexColumn } from "../../../components/Layout/FlexColumn/FlexColumn";
import { FlexRow } from "../../../components/Layout/FlexRow/FlexRow";
import { StyledImage } from "../../../components/Image/Image";
import {
  Body5RegularTypography,
  Caps2BoldTypography,
} from "../../../primitives/Typography/typographyVariants";
import { IMAGE_PREFIX, transformMedia } from "../../../utils/constants";

export const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  paymentMethod,
  dataCy = "payment-method-selector",
}) => {
  const getIconName = (method: string) => {
    switch (method) {
      case "brand_credit":
        return "brand-credit.png";
      case "rupees":
        return "cash.png";
      case "sourcing_coin":
        return "sourcing-coin.png";
      case "barter_credit":
        return "barter.png";
      default:
        return "brand-credit.png";
    }
  };

  const getLabel = (method: string) => {
    switch (method) {
      case "brand_credit":
        return "BRAND CREDIT";
      case "rupees":
        return "RUPEES";
      case "sourcing_coin":
        return "SOURCING COIN";
      case "barter_credit":
        return "BARTER CREDIT";
      default:
        return "";
    }
  };

  return (
    <FlexColumn
      gap={4}
      alignItems="flex-start"
      width="fit-content"
      flexShrink={0}
    >
      <FlexRow gap={4}>
        <StyledImage
          height="16px"
          width="16px"
          objectFit="cover"
          src={transformMedia(`${IMAGE_PREFIX}/${getIconName(paymentMethod)}`)}
        />
        <Body5RegularTypography>Pay Via</Body5RegularTypography>
      </FlexRow>
      <Caps2BoldTypography fontFamily="Lexend">
        {getLabel(paymentMethod)}
      </Caps2BoldTypography>
    </FlexColumn>
  );
};
